import { BASE_URL, COUNTRY_CODE } from "@utils/constants";
import { getCookieValue } from "@utils/helpers";
import axios from "axios";
import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import { mutate } from "swr";

export const postDiscount = async (
  membershipDiscount: Record<
    number,
    {
      UsernameLabel: string;
      PasswordLabel: string;
    }
  >,
  setLoading: Dispatch<SetStateAction<boolean>>,
  setSuccess: (message?: string) => void,
  setFailure: (message: string, isError?: boolean) => void,
  discountId: number,
  isRetro: boolean,
  paQty?: string,
  translations?: ReturnType<
    typeof useTranslations<"Checkout.Cart.tickets.discount">
  >
) => {
  const basketKey = getCookieValue("ASP.NET_SessionId");
  const websiteUid = getCookieValue("itk-website-uid");

  setLoading(true);

  try {
    const response = await axios.post(
      `${BASE_URL}/legacy/${COUNTRY_CODE}/shop/basket/${basketKey}/discount`,
      {
        DiscountId: discountId,
        PaQty: paQty,
        ...(membershipDiscount[discountId].PasswordLabel !== "" &&
          membershipDiscount[discountId].UsernameLabel !== "" && {
            Lastname: membershipDiscount[discountId].UsernameLabel,
            Reference: membershipDiscount[discountId].PasswordLabel,
          }),
        IsRetrospectiveCombo: isRetro,
      },
      {
        headers: {
          "itk-website-uid": websiteUid,
        },
      }
    );

    if (response.status >= 200 && response.status < 300) {
      setSuccess(translations?.("success") ?? "Successfully applied discounts");
      await mutate(`basket/${basketKey}`);
      await mutate(`basket/${basketKey}/summary`);
      await mutate(`basket/${basketKey}/checkout`);
      await mutate(
        (key: any) =>
          Array.isArray(key) && key[0] === `basket/${basketKey}/checkout`
      );
    }
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status < 500) {
      setFailure(translations?.("failure") ?? "Discount unsuccessful");
    } else {
      setFailure(
        translations?.("somethingwentwrong") ?? "Something went wrong.",
        true
      );
    }
  }
  setLoading(false);
};
